import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ValidationSectionBase } from '../../../model/eform/scripts/validation-section.model';

@Injectable({
  providedIn: 'root'
})
export class EFormScriptsService {


  protected resourceUrl: string = "/rest/publicarea/form-script"

  constructor(private http: HttpClient) { }


  public validateSection(serviceInstanceId: number, procedureInstanceId: number, sectionId: number): Observable<{ ok: boolean, entity: ValidationSectionBase, messageCode: string }> {

    return this.http.get<{ ok: boolean, entity: ValidationSectionBase, messageCode: string }>(`${this.resourceUrl}/validate-section/${serviceInstanceId}/${procedureInstanceId}/${sectionId}`).pipe(map(r => {
      if (r.ok) {
        r.entity = ValidationSectionBase.from(r.entity)
      }
      return r
    }))
  }



}
